import './fdx-password-reset-form.styles.scss';
import FdxPasswordResetFormController from './fdx-password-reset-form.controller.js';

angular.module('feedAuthApp').component('fdxPasswordResetForm', {
    template: require('./fdx-password-reset-form.template.html'),
    controller: FdxPasswordResetFormController
});